<template>
    <vue-modal></vue-modal>
    <vue-session-timer></vue-session-timer>
    <vue-header-page></vue-header-page>

    <div class="container">
        <div>
            <h1>Кабинет сотрудника ERP Alfadiesel</h1>
            <h2 v-if="user">{{ user.name }}</h2>
            <p>Май логин: <strong v-if="user">{{ user.login }}</strong></p>
            <p>Аутентифицирован: <strong>{{ isAuth }}</strong></p>
            <!-- <div class="display-grid grid-gap-2 lg:grid-cols-5 md:grid-cols-3 grid-cols-1">
                <div class="btn" @click="testModal('error', 'Ошибка', 'Тут тыкать плохо]')">вызов error</div>
                <div class="btn" @click="testModal('info', 'Инфо', 'Если тыкнули то тыкнули')">вызов info</div>
                <div class="btn" @click="testModal('success', 'Отлично', 'Замечательно тыкнули')">вызов success</div>
            </div> -->
        </div>
        <!-- <textarea style="width: 100%; height: 150px;">{{ user }}</textarea> -->
    </div>

    <vue-working-employee-works></vue-working-employee-works>

    <!-- <vue-footer-page></vue-footer-page> -->
</template>

<script>
// import Logout from '@/VueWorking/Pages/Logout.vue';

export default {
    name: 'Index',
    // components: { Logout },
    data() {
        return {
            isAuthenticated: parseFloat(localStorage.authenticated),
            isAuth: parseFloat(localStorage.authenticated) ? 'Да' : 'Нет',
            user: null,
        }
    },
    mounted(){
        // this.user = this.getUser();
        this.user = this.$store.state.user;
    },
    methods: {
        testModal(type, label, message){
            window.$func.getAlert(type, label, message);
        },
    }
}
</script>